export const BrandProduct = [
    // vimal
    {
        brandId: "vimal",
        Name: "Vimal",
        image: require("../../assets/Images/logo_vimal_agro.png"),

        subBrand: [
            {
                brandproductId: "vimal(1)",
                subBrandImage: "https://www.vimalagro.com/wp-content/uploads/2018/05/aloo_mutter_list-1.png",
                subBrandtittle: "Aloo Mutter",
                subbrandDetails: [
                    {
                        ProductImage: "https://www.vimalagro.com/wp-content/uploads/2018/05/aloo_mutter_list-1.png",
                        ProductTittle: "Aloo Mutter",
                        Productsubtittle: "Ready 2 Eat Aloo Mutter",
                        productInfo: "You will love this tasty Indian meal of potatoes and peas which is spiced perfectly and very filling. Aloo Mutter goes well with rice or chappatis."
                    }
                ]
            },
        ]
    },

    // swad
    {
        brandId: "swad",
        Name: "Swad",
        image: require("../../assets/Images/swad_logo_copy.png"),

        subBrand: [
            {
                brandproductId: "swad(1)",
                subBrandImage: "https://www.vimalagro.com/wp-content/uploads/2018/03/sarson_da_sag_large.png",
                subBrandtittle: "Sarson Da Saag",
                subbrandDetails: [
                    {
                        ProductImage: "https://www.vimalagro.com/wp-content/uploads/2018/03/sarson_da_sag_large.png",
                        ProductTittle: "Sarson Da Saag",
                        Productsubtittle: "Swad's Sarson Da Saag",
                        productInfo: "Sarson Da Saag is a popular Punjabi recipe, often enjoyed with Makki Ki Roti during winters. Mustard leaves and spinach form the base of this curry, are rife with Vitamins A, C, E, K, B1, B2, B6. Also an excellent source of calcium and zinc. Swad’s Sarson Da Saag has got you covered not only for winters but for the entire year. Because food cravings are mostly uninvited and unplanned."
                    }
                ]
            }
        ]
    },
    // bvitas
    {
        brandId: "bvitas",
        Name: "Bvitas",
        image: require("../../assets/Images/b_vitas_logo_copy.png"),
        weblink: "https://www.bvitas.com/",
    },
    // big pantry
    {
        brandId: "big pantry",
        Name: "Big Pantry",
        image: "https://bigpantry.in/wp-content/uploads/2024/06/logo-web-2048x1106.jpg",


        subBrand: [
            {
                brandproductId: "big pantry(1)",
                subBrandImage: "https://www.vimalagro.com/wp-content/uploads/2018/05/brinjal_product.png",
                subBrandtittle: "Brinjal Chutney",
                subbrandDetails: [
                    {
                        ProductImage: "https://www.vimalagro.com/wp-content/uploads/2018/05/brinjal_product.png",
                        ProductTittle: "Brinjal Chutney",
                        Productsubtittle: "Big Pantry Brinjal Chutney",
                        productInfo: "Brinjal Chutney is a personal favourite vegetable of mine and I hardly tire of brinjal dishes. I love all varieties of chutneys too and like experimenting with different vegetable and spice combinations."
                    }
                ]
            }
        ]
    },




]